import {
  hasUrlOrTaskQuestion,
  resolveQuestionKind,
} from '@/shared-question-model';

import type { ResponderQuestionInput } from './shared-responder-v2-project.types';

/**
 * Whether the project records a screen — the same question the session builder
 * asks of its own specs, asked here of the neutral project input before any
 * session exists. The kind has to be resolved first because a URL or Task
 * question is a shape, not a field.
 */
export function hasUrlOrTaskResponderQuestion(
  questions: readonly ResponderQuestionInput[]
): boolean {
  return hasUrlOrTaskQuestion(
    questions.map((question) => ({
      kind: resolveQuestionKind({
        questionShape: question.questionShape,
        optionRenderType: question.optionRenderType,
        subQuestionCount: question.subQuestions?.length ?? 0,
        isContactInfo: question.isContactInfo,
      }),
      contentUrl: question.contentUrl,
      text: question.text,
    }))
  );
}
